import { render } from "./ProductSetItemSplitField.vue?vue&type=template&id=0bb955dc"
import script from "./ProductSetItemSplitField.vue?vue&type=script&lang=js"
export * from "./ProductSetItemSplitField.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__